// src/lib/dashboard/janelaParaDatasDia.ts
import type { JanelaPeriodo } from './periodoDashboard.ts';

function formatarDataISO(d: Date): string {
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// Marketing consulta por data solta (YYYY-MM-DD), não por mes_referencia — essa
// função converte a janela de mês do filtro do dashboard numa data de início
// (dia 1 do primeiro mês) e fim (último dia do mês final). Quando a janela é
// null (preset "histórico"), não há limite inferior real — usamos uma data
// bem no passado como início e hoje como fim, já que
// api.marketing.getMetrics exige os dois parâmetros preenchidos.
export function janelaParaDatasDia(janela: JanelaPeriodo | null, hoje: Date): { inicio: string; fim: string } {
  if (!janela) {
    return { inicio: '2000-01-01', fim: formatarDataISO(hoje) };
  }
  const inicio = new Date(janela.inicio.getFullYear(), janela.inicio.getMonth(), 1);
  const fim = new Date(janela.fim.getFullYear(), janela.fim.getMonth() + 1, 0); // último dia do mês de `fim`
  return { inicio: formatarDataISO(inicio), fim: formatarDataISO(fim) };
}
